import { Component, EventEmitter, Input, Output } from '@angular/core';
import { Station } from '../../../../../../client/model/station';

@Component({
    selector: 'app-sac-mobile-station-title',
    templateUrl: './station-title.component.html',
    styleUrls: ['./station-title.component.scss'],
    standalone: false
})
export class MobileSacStationTitleComponent {

  @Input() station: Station;

  @Output() onSearchClick = new EventEmitter<void>();

  clickSearch() {
    this.onSearchClick.emit();
  }

}
